import React from 'react'
import { connect } from 'react-redux'
import { store } from '../store'
import { push } from 'react-router-redux'
import agent from '../agent';
import {
  CATEGORY_ADD_PAGE_UNLOADED,
  CATEGORY_ADD,
  REDIRECT
} from '../constants/actionTypes'
import Header from './widgets/Header'
import CrumbBox from './widgets/CrumbBox'
import { BASE_COIN_SYMBOL } from '../constants/config'
import ListErrors from './ListErrors'
const mapStateToProps = state => ({
  ...state.settings,
  currentUser: state.common.currentUser,
  inProgress: state.common.inProgress
})

const mapDispatchToProps = dispatch => ({
  onSubmit: (payload) => {
    dispatch({ type: CATEGORY_ADD, payload })
  },
  onUnload: () =>
    dispatch({ type: CATEGORY_ADD_PAGE_UNLOADED }),
  onRedirect: () =>
    dispatch({ type: REDIRECT })
})

class CategoryAdd extends React.Component {
  constructor() {
    super();
    this.state = {
      name: '',
    }
    this.updateState = field => ev => {
      const state = this.state;
      const newState = Object.assign({}, state, { [field]: ev.target.value });
      this.setState(newState);
    }
    this.submitForm = (name) => ev => {
      ev.preventDefault();
      const payload = agent.Categories.addCategory(name)
      this.props.onSubmit(payload);
    }
  }
  componentWillMount() {
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.updated === true) {
      store.dispatch(push('/categories/manage'))
      this.props.onRedirect()
    }
  }
  componentWillUnmount() {
    this.props.onUnload();
  }

  render() {
    if (!this.props.currentUser) {
      return (
        null
      )
    }
    const name = this.state.name;

    return (
      <div>
        <Header />
        <CrumbBox data={[{ key: 'Add Category' }]} rootKey='/settings' rootVal='Settings' />
        <div id="focus">
          <div id="main">
            <div id="main-wrap">
              <div id="focus-wrap">
                <h2>Add Category</h2>
                <div className="FormItem">
                  <label>Name</label>
                  <input type="text"
                    placeholder="Name"
                    value={name}
                    onChange={this.updateState('name')} />
                </div>
                <ListErrors errors={this.props.errors} />
                <div className="FormItem">
                  <button type="button" onClick={this.submitForm(name)} disabled={this.props.inProgress}>Create Category</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CategoryAdd)
